import React, { Fragment } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { Breadcrumbs } from '../../../../AbstractElements';
import EditAvis from './EditAvis';
import i18n from '../../../../i18n';

const SingleAvis = () => {

    const { id } = useParams();

    return (
        <Fragment>
            <Breadcrumbs mainTitle={ `${i18n.t('Dashboard_Avis_Title')} n°${id}` } parent={i18n.t('Dashboard_Avis_List')} title={i18n.t('Dashboard_Avis_Title')} />
            <Container fluid={true}>
                <div className="edit-profile">
                    <Row>
                        <Col xl="10">
                            <EditAvis avis={id} />
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    );
};
export default SingleAvis;
